module.exports = __webpack_public_path__ + "b132c1d75cdaec8504c994ce49d3a3a2.png";